module.exports = __webpack_public_path__ + "static/img/oddnary-variation-4.a93863d9.jpg";